import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

import { BecomeLogo } from "./BecomeLogo";

const footerLinks = {
  navigation: [
    { name: "Home", path: "/" },
    { name: "How It Works", path: "/how-it-works" },
    { name: "Meet Your Team", path: "/team" },
    { name: "Why Become", path: "/why-become" },
  ],
  company: [
    { name: "About Us", path: "/about" },
    { name: "Blog", path: "/blog" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact", path: "/contact" },
    { name: "Privacy Policy", path: "/privacy" },
    { name: "Terms of Service", path: "/terms" },
  ],
};

const contactInfo = [
  { icon: Mail, href: "mailto:jintile@levoarc.com", label: "Email" },
];

export const Footer = () => {
  return (
    <footer className="bg-deep-violet text-text-light" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <BecomeLogo size="default" showText={true} />
            </Link>
            <p className="text-text-light/60 text-sm leading-relaxed mb-6">
              Reflect. Discover. Become.
            </p>
            <p className="text-brand-peach/80 text-xs font-medium">
              Not everyone has a support system.
              <br />
              This app becomes yours.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-brand-peach font-heading text-lg mb-6">Navigate</h3>
            <ul className="space-y-4">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-text-light/70 hover:text-brand-peach transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-brand-peach font-heading text-lg mb-6">Company</h3>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-text-light/70 hover:text-brand-peach transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Security */}
          <div>
            <h3 className="text-brand-peach font-heading text-lg mb-6">Contact</h3>
            <div className="flex gap-4 mb-8">
              {contactInfo.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-peach/20 transition-colors"
                  aria-label={item.label}
                  data-testid={`footer-contact-${item.label.toLowerCase()}`}
                >
                  <item.icon size={18} className="text-text-light/70" />
                </a>
              ))}
            </div>
            <div className="p-4 rounded-xl bg-white/5 border border-white/10">
              <p className="text-xs text-text-light/50 leading-relaxed">
                Built with professional expertise and Zero Trust security
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-text-light/40 text-sm">
              © 2026 Become. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-text-light/40 hover:text-text-light text-sm transition-colors" data-testid="footer-bottom-privacy">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-text-light/40 hover:text-text-light text-sm transition-colors" data-testid="footer-bottom-terms">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
